<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <div class="row mb-2 pt-3">
    <div class="col">
      <div class="row">
        <div class="col-6">
          <h4>Certifications</h4>
        </div>

        <div *ngIf="certifications && certifications.length > 0" class="col-6 text-right">
          <button class="btn btn-sm btn-admin-primary" type="button" (click)="add()">Add Certification</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row no-gutters no-candidates" style="min-height: 200px" *ngIf="!certifications || certifications.length == 0">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Certifications</h4>
      <p>You have not added any certifications yet. You will need to add certifications to claim CEUs.</p>
      <button class="btn btn-sm btn-admin-primary" type="button" (click)="add()">Add Certification</button>

    </div>
  </div>
  <div *ngIf="certifications && certifications.length > 0" class="row">
    <div class="col-md-12">
      <table class="table mobile-xs-table table-bordered-outside table-hover mb-0 bg-white">
        <thead class="bg-light">
          <tr>
            <th>Certification Body</th>
            <th>Certification #</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let certification of certifications">
            <td class="drag-col-md full-width" style="white-space: nowrap">
              <a href="javascript:void(0)" (click)="edit(certification)"> {{ certification.certificationBody.name }} </a>
            </td>
            <td>{{ certification.certificationNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
